import React, { Component } from "react";

export default class Products extends Component {
	constructor() {
      super();
			this.state={

  }
	}
	render() {
		const brands = [
			{
				name: "Amarr",
				logo: "/images/logo-amarr.png",
				description: "Premium garage doors with innovative designs and superior craftsmanship."
			},
			{
				name: "Genie",
				logo: "/images/logo-genie.png",
				description: "Reliable garage door openers and accessories for every home."
			},
			{
				name: "LiftMaster",
				logo: "/images/logo-liftmaster.png",
				description: "The world's most trusted brand in garage door openers and accessories."
			},
			{
				name: "Wayne Dalton",
				logo: "/images/logo-waynedalton.png",
				description: "Quality garage doors with innovative technology and design."
			},
			{
				name: "Northwest Door",
				logo: "/images/logo-northwestdoor.png",
				description: "Custom garage doors built to your specifications."
			},
			{
				name: "Garage Doors Inc",
				logo: "/images/logo-garagedoorsinc.png",
				description: "Professional garage door solutions for residential and commercial applications."
			}
		];

		return (
      <div>
        {/* Header */}
        <div className="primary-background large-padding centered-text">
          <h1 className="white">Our Products</h1>
          <p className="white subheading">Quality garage doors and openers from trusted manufacturers</p>
        </div>

        {/* Brands Section */}
        <div className="white-background large-padding">
          <div className="row centered-text">
            <div className="small-12">
              <h2 className="primary-color">Trusted Brands</h2>
              <p className="subheading">We work with the industry's leading manufacturers to provide you with the best quality and selection.</p>
            </div>
          </div>
          
          <div className="row">
            {brands.map((brand, index) => (
              <div key={index} className="small-12 medium-6 large-4 small-padding">
                <div className="light-grey-background small-padding centered-text" style={{borderRadius: "8px", height: "100%"}}>
                  <img 
                    src={brand.logo} 
                    alt={brand.name}
                    style={{maxWidth: "200px", maxHeight: "100px", marginBottom: "15px"}}
                  />
                  <h4 className="primary-color">{brand.name}</h4>
                  <p className="subheading">{brand.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Product Categories */}
        <div className="light-grey-background large-padding">
          <div className="row">
            <div className="small-12">
              <h2 className="primary-color centered-text">Product Categories</h2>
            </div>
          </div>
          
          <div className="row">
            <div className="small-12 medium-6 large-3 small-padding">
              <div className="white-background small-padding centered-text" style={{borderRadius: "8px", height: "100%"}}>
                <h4 className="primary-color">Residential Doors</h4>
                <p>Single and double garage doors for homes of all sizes</p>
                <ul className="primary-color text-left">
                  <li>Steel garage doors</li>
                  <li>Wood garage doors</li>
                  <li>Aluminum garage doors</li>
                  <li>Fiberglass garage doors</li>
                </ul>
              </div>
            </div>
            
            <div className="small-12 medium-6 large-3 small-padding">
              <div className="white-background small-padding centered-text" style={{borderRadius: "8px", height: "100%"}}>
                <h4 className="primary-color">Commercial Doors</h4>
                <p>Heavy-duty doors for commercial and industrial applications</p>
                <ul className="primary-color text-left">
                  <li>Sectional overhead doors</li>
                  <li>Roll-up doors</li>
                  <li>High-speed doors</li>
                  <li>Fire-rated doors</li>
                </ul>
              </div>
            </div>
            
            <div className="small-12 medium-6 large-3 small-padding">
              <div className="white-background small-padding centered-text" style={{borderRadius: "8px", height: "100%"}}>
                <h4 className="primary-color">Door Openers</h4>
                <p>Automatic garage door openers and accessories</p>
                <ul className="primary-color text-left">
                  <li>Chain drive openers</li>
                  <li>Belt drive openers</li>
                  <li>Screw drive openers</li>
                  <li>Smart openers</li>
                </ul>
              </div>
            </div>
            
            <div className="small-12 medium-6 large-3 small-padding">
              <div className="white-background small-padding centered-text" style={{borderRadius: "8px", height: "100%"}}>
                <h4 className="primary-color">Accessories</h4>
                <p>Complete your garage door system with quality accessories</p>
                <ul className="primary-color text-left">
                  <li>Remote controls</li>
                  <li>Keypads</li>
                  <li>Safety sensors</li>
                  <li>Weather seals</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Our Products */}
        <div className="white-background large-padding">
          <div className="row">
            <div className="small-12">
              <h2 className="primary-color centered-text">Why Choose Our Products?</h2>
            </div>
          </div>
          
          <div className="row">
            <div className="small-12 medium-4 small-padding centered-text">
              <h4 className="primary-color">Quality Assurance</h4>
              <p>All products come with manufacturer warranties and our installation guarantee.</p>
            </div>
            <div className="small-12 medium-4 small-padding centered-text">
              <h4 className="primary-color">Expert Installation</h4>
              <p>Our certified technicians ensure proper installation for optimal performance and safety.</p>
            </div>
            <div className="small-12 medium-4 small-padding centered-text">
              <h4 className="primary-color">Competitive Pricing</h4>
              <p>We offer competitive prices on all products with no hidden fees or charges.</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="primary-background large-padding centered-text">
          <h3 className="white">Ready to Get Started?</h3>
          <p className="white subheading">Contact us for a free estimate on your garage door project</p>
          <a href="tel:(650) 255-4768" className="button accent-background white large-margin-top">
            Call (650) 255-4768
          </a>
        </div>
      </div>
		)
	}
} 


// WEBPACK FOOTER //
// ./src/pages/products/index.js